{
    "AppMenu_AppsTitle": "Speisekarte",
    "AppMenu_Apps_Reporting": "Analysen",
    "AppMenu_Apps_FastProvisioning": "Schnelle Bereitstellung",
    "AppMenu_Apps_Administration": "Verwaltung",
    "AppMenu_Apps_StatusAndTools": "Status und Tools",
    "AppMenu_FavouritesTitle": "Favoriten",
    "NAME": "AppMenu",
    "AppMenu_NewUI": "CX Suite",
    "AppMenu_ClassicUI": "Klassischer Look",
    "AppMenu_NewUIBadge": "Neu",
    "AppMenu_NewUIInvite_AriaLabel": "Testen Sie CX Suite",
    "AppMenu_NewUIInvite_Heading": "Schauen Sie sich die CX Suite an.",
    "AppMenu_NewUIInvite_Body": "Eine schnellere Startseite, übersichtlichere Berichte und eine klarere Navigation. Probieren Sie es aus – Sie können jederzeit wieder zurückwechseln.",
    "AppMenu_NewUIInvite_Confirm": "Hör zu",
    "AppMenu_NewUIInvite_Dismiss": "Nicht jetzt."
}